import React from "react";
import { Link } from "react-router-dom";
import { loadStripe } from '@stripe/stripe-js';
import Loader from "app/components/shared/app/Loader";
import Button from 'components/shared/app/Button';
import arrowIcon from 'static/icons/icon_arrow_blue_round.svg';
import './style.scss'

const elementStyle = {
    base: {
        iconColor: '#666EE8',
        color: '#fff',
        lineHeight: '40px',
        fontSize: '16px',
        fontFamily: '"Arial"',

        '::placeholder': {
            color: '#fff',
        },
    },
};

// TODO: turn into functional component

export default class BillingForm extends React.Component {

    stripe;
    elements;
    cardNumberElement;
    cardExpiryElement;
    cardCvcElement;
    cardPostalElement;

    state = {
        loading: false,
        plans: [],
        formErrors: [],
        termsAgreed: false,
        plan_name: "",
        plan_price: "",
        plan_ext: "",

        // using defaults here to signify base case of the stripe elements onChange handler
        stripe_cc_error: "Card number is required.",
        stripe_exp_error: "Expiration is required.",
        stripe_cvc_error: "CVC is required.",
        stripe_zip_error: "Zipcode is required."
    };

    componentDidMount() {
        this.initStripe();
    }

    initStripe() {
        const self = this;

        // init stripe + form
        loadStripe(process.env.STRIPE_API_KEY).then(stripe => {
            this.stripe = stripe;
            this.elements = stripe.elements();

            this.cardNumberElement = this.elements.create('cardNumber', {
                style: elementStyle,
                placeholder: 'Credit card number'
            });
            this.cardNumberElement.mount('#card-number-element');
            this.cardNumberElement.on('change', (e) => {
                let error = undefined;
                if (e.error) {
                    error = e.error.message;
                } else if (e.empty) {
                    error = "Card number is required."
                }
                self.setState({
                    stripe_cc_error: error
                });
            });

            this.cardExpiryElement = this.elements.create('cardExpiry', {
                style: elementStyle,
                placeholder: 'Exp',
            });
            this.cardExpiryElement.mount('#card-expiry-element');
            this.cardExpiryElement.on('change', (e) => {
                let error = undefined;
                if (e.error) {
                    error = e.error.message;
                } else if (e.empty) {
                    error = "Expiration is required."
                }
                self.setState({
                    stripe_exp_error: error
                });
            });

            this.cardCvcElement = this.elements.create('cardCvc', {
                style: elementStyle,
                placeholder: 'CVC',
            });
            this.cardCvcElement.mount('#card-cvc-element');
            this.cardCvcElement.on('change', (e) => {
                let error = undefined;
                if (e.error) {
                    error = e.error.message;
                } else if (e.empty) {
                    error = "CVC is required."
                }
                self.setState({
                    stripe_cvc_error: error
                });
            });

            this.cardPostalElement = this.elements.create('postalCode', {
                style: elementStyle,
                placeholder: 'ZIP',
            });
            this.cardPostalElement.mount('#card-postal-element');
            this.cardPostalElement.on('change', (e) => {
                let error = undefined;
                if (e.error) {
                    error = e.error.message;
                } else if (e.empty) {
                    error = "Zipcode is required."
                }
                self.setState({
                    stripe_zip_error: error
                });
            });
        });
    }

    getFieldError(field) {
        return this.state.formErrors ? this.state.formErrors.find((_e) => _e.field === field) : undefined;
    }

    toggleTerms() {
        this.setState({
            termsAgreed: !this.state.termsAgreed
        })
    }

    submitForm = () => {
        console.log('submitForm')
        const self = this;

        this.setState({ formErrors: [] });

        let errors = [];

        if (this.state.stripe_cc_error) {
            errors.push({ field: "stripe_cc", error: this.state.stripe_cc_error });
        }

        if (this.state.stripe_cvc_error) {
            errors.push({ field: "stripe_cvc", error: this.state.stripe_cvc_error });
        }

        if (this.state.stripe_exp_error) {
            errors.push({ field: "stripe_exp", error: this.state.stripe_exp_error });
        }

        if (this.state.stripe_zip_error) {
            errors.push({ field: "stripe_zip", error: this.state.stripe_zip_error });
        }

        if (!this.state.termsAgreed && ((typeof this.props.agreeToTerms == 'undefined') ||
            ((typeof this.props.agreeToTerms != 'undefined') && (this.props.agreeToTerms == true)))) {
            errors.push({ field: "confirmTerms", error: "Please agree to terms" });
        }

        if (errors.length) {
            console.log('errors', errors)
            return this.setState({ formErrors: [ ...errors ] });
        }

        console.log('VALID');
        // make stripe token for card
        let zip = document.getElementById('card-postal-element').value;

        this.setState({ loading: true });

        this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardNumberElement,
            billing_details: {
                address: {
                    postal_code: zip
                }
            }
        })
        .then(r => {
            this.setState({ loading: false });

            if (r.paymentMethod) {
                let pd = {
                    paymentId: r.paymentMethod.id
                }

                self.props.onCardSubmit(pd);
            } else {
                console.log('error processing', r);
                self.props.onError("Oops! There was an error processing your payment. Please try again. If this continues to happen, please contact us at support@esupporthealth.com.");
            }
        });
    }

    render() {
        let planPrice = '$99';
        return (

            <form className="form" id="billing-form">

                <div className="payment-details section">
                    <div className="row flex-row">
                        <div id="card-number-element" className="field"></div>
                    </div>
                    { this.getFieldError('stripe_cc') !== undefined && <div className="field-error">{this.getFieldError('stripe_cc').error}</div> }
                    <div className="row flex-row">
                        <div id="card-expiry-element" className="field"></div>
                        <div id="card-cvc-element" className="field"></div>
                        <div id="card-postal-element" className="field"></div>
                    </div>
                    { this.getFieldError('stripe_exp') !== undefined && <div className="field-error">{this.getFieldError('stripe_exp').error}</div> }
                    { this.getFieldError('stripe_cvc') !== undefined && <div className="field-error">{this.getFieldError('stripe_cvc').error}</div> }
                    { this.getFieldError('stripe_zip') !== undefined && <div className="field-error">{this.getFieldError('stripe_zip').error}</div> }

                </div>

                <div className="field agree-to-terms">
                    <label>
                        <input id="terms_conditions" className="uk-checkbox" type="checkbox" checked={this.state.termsAgreed} onChange={() => this.toggleTerms()}></input>
                        I accept the<Link to="/privacy">Terms &amp; Conditions</Link>
                    </label>
                    { this.getFieldError('confirmTerms') !== undefined && <div className="field-error">{this.getFieldError('confirmTerms').error}</div> }
                </div>

                <div className="buttons">
                    <Button className="submit" round simple bold filled center color="white" icon={<img src={arrowIcon} />} iconPosition="right" textPosition="center" onClick={this.submitForm}>
                        { this.props.saveLabel || "Submit" }
                    </Button>

                </div>

            </form>

        );
    }

}
